import React, { useState } from 'react';
import { IoMdAdd } from "react-icons/io";
import { RiCoinsLine, RiDeleteBin6Line } from "react-icons/ri";
import DoubleSlider from "../../SideBarSection/DoubleSlider/DoubleSlider.js";
import './FilterBox.css'

import { TbDatabaseSearch } from "react-icons/tb";
import { BsTrash3Fill } from "react-icons/bs";
import { FaWindowClose } from "react-icons/fa";

const FilterBox = ({ onClose, handleSecondFilter, ListMaterial , shapeParams}) => {
  const [fields, setFields] = useState([{ selectedElement: '', inputValue: '', inputParam : {} , Unit : ''}]);
  const elements = ['Geometry', 'Materials', 'Frequency', 'Vacuum Wavelength'];
  const [spectrunUnit, setSpectrumUnit] = useState({ 'Frequency': 'THz', 'Vacuum Wavelength': 'nm' });
   const [ranges, setRanges] = useState({});  
 // const [unit, setUnit] = useState('');

  

 
  const handleSelectChange = (index, event) => {
    const newFields = [...fields];
  
    newFields[index].selectedElement = event.target.value;
    
    newFields[index].selectedElement = event.target.value;
    newFields[index].inputValue = ""; 
    setFields(newFields);
  };

  
  const handleInputChange = (index, event) => {
    const newFields = [...fields];
    newFields[index].inputValue = event.target.value;
    setFields(newFields);
  };

  const handleAddField = () => {
    setFields([...fields, { selectedElement: '', inputValue: '', inputParam : {} , Unit : '' }]);
  };

  const handleRemoveField = (index) => {
    const newFields = fields.filter((_, i) => i !== index);
    setFields(newFields);
  };

  const handleApplyFilter = () => {
    handleSecondFilter(fields);
  };

  const handleRangeChange = (index, range) => {
    const newFields = [...fields];
    newFields[index].inputValue = range;
    //newFields[index].Unit = unit;
    setFields(newFields);
  };

  const handleParamChange = (param, value, index) => {
    const newFields = [...fields];
  
    if (!newFields[index]) {
      newFields[index] = {};
    }
    if (!newFields[index].inputParam) {
      newFields[index].inputParam = {};
    }
  
    newFields[index].inputParam[param] = value;
  
    setFields(newFields);
  };
  
  const handleMinChange = (e, index) => {
    const param = e.target.name;
    const newMin = e.target.value;
    const currentRange = fields[index]?.inputParam?.[param] || [0, 0];
  
    handleParamChange(param, [newMin, currentRange[1]], index);
  };
  
  const handleMaxChange = (e, index) => {
    const param = e.target.name;
    const newMax = e.target.value;
    const currentRange = fields[index]?.inputParam?.[param] || [0, 0];
  
    handleParamChange(param, [currentRange[0], newMax], index);
  };
  


const UpdateUnit = (index, unit) =>{

  const newFields = [...fields];

  newFields[index].Unit = unit;


  setFields(newFields);


}

  return (
    <div className="tmatrix-modal-backdrop-filter" onClick={onClose}>
      <div className="tmatrix-modal-content-filter" onClick={(e) => e.stopPropagation()}>

              <div className="filter-header-row">
          <h2 className="filter-title">Filter Options</h2>

          <div className="icon-row">
            <div className="icon-wrapper" data-tooltip="Search">
              <TbDatabaseSearch className="icon-clear" onClick={handleApplyFilter} />
            </div>

            <div className="icon-wrapper" data-tooltip="Add Field">
              <IoMdAdd className="icon-clear" onClick={handleAddField} />
            </div>

            <div className="icon-wrapper" data-tooltip="Close">
              <FaWindowClose className="icon-clear" onClick={onClose} />
            </div>
          </div>
        </div>


        <div className="filter-fields">
          
          {fields.map((field, index) => (
            
            <div key={index} className="list-select-filter">

          
              <div className="icon-wrapper" data-tooltip="Remove">
                     <BsTrash3Fill className="icon-clear" onClick={() => handleRemoveField(index)} />
                     </div>
              <select id={`element-select-${index}`} value={field.selectedElement} onChange={(e) => handleSelectChange(index, e)} className="input-menu-filter">
                <option value="" disabled>Select...</option>
                {elements.map((element) => (
                  <option key={element} value={element}>{element}</option>
                ))}
              </select>
              {['Frequency', 'Vacuum Wavelength'].includes(field.selectedElement) && (
                <div className="range-container">
                  <label htmlFor={`element-value-${index}`} className="label">
                    {`Select ${field.selectedElement} Range in ${spectrunUnit[field.selectedElement]}:`}
                  </label>
                  <DoubleSlider min={0} max={0} onChange={(range) => handleRangeChange(index, range)} selectedElement={field.selectedElement} handleUnit = {((unit) => {UpdateUnit(index, unit)})} />
                </div>
              )}
                {field.selectedElement === "Geometry" && (
                <div className="nested-select-container">
                <select
                  id={`geometry-select-${index}`}
                  value={field.inputValue}
                  onChange={(e) => handleInputChange(index, e)}
                  className="input-menu-filter"
                >
                  <option value="" disabled>Select...</option>
                  {Object.keys(shapeParams) && <option value="clear">Clear selection</option>}
                  {Object.keys(shapeParams).map((element) => (
                    <option key={element} value={element}>{element}</option>
                  ))}
                </select>
                </div>
                )}


              {
                field.selectedElement === "Geometry" &&
                field.inputValue &&
                shapeParams[field.inputValue] && (
                  <div key={index} className="modal-content-filter">
                    <h3>{field.inputValue} Parameters</h3>
                    <ul>
                      {shapeParams[field.inputValue].map((param, paramIndex) => (
                        <li key={paramIndex}>
                          <label>{param} (nm): </label>
                          <div className="input-group">
                            <div className="input-wrapper">
                              <label htmlFor="min-input" className="input-label">Min Value:</label>
                              <input
                                type="text"
                                name={param}
                                value={field.inputParam?.[param]?.[0] || ''}
                                onChange={(e) => handleMinChange(e, index)}
                                className="input-field-slider"
                              />
                            </div>
                            <div className="input-wrapper">
                              <label htmlFor="max-input" className="input-label">Max Value:</label>
                              <input
                                type="text"
                                name={param}
                                value={field.inputParam?.[param]?.[1] || ''}
                                onChange={(e) => handleMaxChange(e, index)}
                                className="input-field-slider"
                              />
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
              }

                {/*field.selectedElement === "Geometry" && field.inputValue && shapeParams[field.inputValue] && (
                <div className="modal-content-filter">
                <h3>{field.inputValue} Parameters</h3>
                <ul>
                  {shapeParams[field.inputValue].map((param, paramIndex) => (
                    <li key={paramIndex}>
                      <label>{param} (nm): </label>
                     {/* <input
                        type="text"
                        name={param}
                        value={field.inputParam?.[param] || ""}
                        onChange={(e) => handleParamChange(e, param, index)}
                      />}
                      <div className="input-group">
                                        <div className="input-wrapper">
                                        <label htmlFor="min-input" className="input-label">Min Value:</label>
                                        <input
                                            type="text"
                                            name={param}
                                            value={ranges[param]?.[0] || ''}
                                            onChange={handleMinChange}
                                            className="input-field-slider"
                                        />
                                        </div>
                                        <div className="input-wrapper">
                                        <label htmlFor="max-input" className="input-label">Max Value:</label>
                                        <input
                                             type="text"
                                             name={param}
                                             value={ranges[param]?.[1] || ''}
                                             onChange={handleMaxChange}
                                            className="input-field-slider"
                                        />
                                        </div>
                                    </div>
                    </li>
                  ))}
                </ul>
                </div>
                )*/}


              {field.selectedElement === 'Materials' && (
                <div className="nested-select-container">
                  <select id={`material-select-${index}`} value={field.inputValue} onChange={(e) => handleInputChange(index, e)} className="input-menu-filter">
                    <option value="" disabled>Select...</option>
                    {ListMaterial.map((element) => (
                      <option key={element} value={element} >{element}</option>
                    ))}
                  </select>
                </div>
              )}
              
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default FilterBox;
